module.exports = __webpack_public_path__ + "static/media/icon_submenu.aa1203f5.svg";